<template>
  <div class="arcgis-map-container">
    <b-card class="p-0 filter-card rounded-lg">
      <b-row>
        <b-col cols="3">
          <b-form-input
            v-model="filter.search"
            placeholder="بحث بأسم او رقم المشروع"
          />
        </b-col>
        <b-col
          v-if="status_data"
          sm="6"
          md="3"
        >
          <v-select
            v-model="filter.status"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="status_data"
            class="w-100 mb-0"
            :reduce="(val) => val"
            placeholder="User Status"
            :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
          >
            <template v-slot:option="option">
              {{ $i18n.locale == "ar" ? option.name_local : option.name }}
            </template>
            <template #selected-option="{ name, name_local }">
              <div style="display: flex; align-items: baseline">
                <strong v-if="$i18n.locale == 'ar'">{{ name_local }} </strong>
                <strong v-else>{{ name }} </strong>
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col>
        <b-col
          v-if="serviceTypes.length > 0"
          sm="6"
          md="3"
        >
          <v-select
            v-model="filter.service_type_id"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="serviceTypes"
            :get-option-label="option => option.name"
            class="w-100 mb-0"
            :reduce="(val) => val.id"
            placeholder="نوع الخدمة"
          >
            <template v-slot:option="option">
              {{ $i18n.locale == "ar" ? option.name_ar : option.name }}
            </template>
            <template #selected-option="{ name_ar }">
              <div style="display: flex; align-items: baseline">
                <strong v-if="$i18n.locale == 'ar'">{{ name_ar }} </strong>
                <strong v-else>{{ name_ar }} </strong>
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col>
        <b-col
          sm="6"
          md="3"
        >
          <b-form-group label-for="basemap-select">
            <v-select
              id="basemap-select"
              v-model="selectedBasemap"
              :options="basemapOptions"
              :reduce="val => val.value"
              :get-option-label="option => option.label"
            >
              <template #option="{ label }">
                <span>{{ label }}</span>
              </template>
              <template #selected-option="{ label }">
                <span>{{ label }}</span>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <div class="map-container-wrapper">
      <div
        v-if="loadMap"
        class="text-center"
      >
        <b-spinner
          variant="primary"
          label="جار تحديث البيانات..."
          type="border"
        />
      </div>
      <div
        ref="mapDiv"
        style="width: 100%; aspect-ratio: 16/10; height: 500px;"
      />
    </div>

  </div>
</template>

<script>
import { loadArcgisModules, destroyArcgisView } from '@/utils/arcgisLoader'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import {
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BRow,
  BCol,
  BCard,
  BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'ProjectsMap',
  components: {
    vSelect,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BRow,
    BCol,
    BCard,
    BSpinner,
  },
  computed: {
    ...mapGetters({
      mapData: 'projects/mapData',
      loadMap: 'projects/loadMap',
      serviceTypes: 'serviceTypes/serviceTypes',
      fixedPoints: 'fixedPoints/fixedPoints',
      fixedPointsLoading: 'fixedPoints/load',
    }),
  },
  data() {
    return {
      basemapOptions: [
        // { value: 'topo-vector', text: 'طبوغرافية' },
        { value: 'osm', label: 'OpenStreetMap' },
        { value: 'satellite', label: 'الخرائط الفضائية' },
        { value: 'streets', label: 'الخرائط العادية' },
        { value: 'hybrid', label: 'مختلط' },
        { value: 'topo', label: 'طبوغرافي' },
        { value: 'gray', label: 'رمادي' },
        { value: 'dark-gray', label: 'رمادي داكن' },
        { value: 'oceans', label: 'المحيطات' },
      ],
      selectedBasemap: 'hybrid',
      status_data: [
        'planning', 'active', 'on_hold', 'completed', 'cancelled',
      ],
      filter: {
        service_type_id: null,
        status: null,
        search: null,
      },
      clusterProjectIndexes: [], // will store projects shown for each cluster
    }
  },
  watch: {
    'filter.service_type_id': function (newVal) {
      newVal == '' ? this.filter.service_type_id = null : this.filter.service_type_id = newVal
      // this.$store.dispatch("projects/listProjects", { query: {...this.filter , page: 1} });
      this.init()
      this.initMap()
    },
    'filter.search': function (newVal) {
      newVal == '' ? this.filter.search = null : this.filter.search = newVal
      // this.$store.dispatch("projects/listProjects", { query: {...this.filter , page: 1} });
      this.init()
      this.initMap()
    },
    'filter.status': function (newVal) {
      newVal == '' ? this.filter.status = null : this.filter.status = newVal
      // this.$store.dispatch("projects/listProjects", { query: {...this.filter , page: 1} });
      this.init()

      this.initMap()
    },
    mapData(newVal) {
      if (this.centroidLayer && this.ArcGISFeatureLayer) {
        this.initCentroidClusters(this.ArcGISFeatureLayer, this.ArcGISGraphic)
      }
    },
    fixedPoints: {
      handler(newVal) {
        console.log('FixedPoints watcher triggered, data:', newVal)
        if (this.map && this.ArcGISPoint && newVal) {
          this.$nextTick(() => {
            this.renderFixedPoints()
          })
        }
      },
      deep: true,
      immediate: false,
    },
  },
  created() {
    // ArcGIS objects must stay off Vue's reactive data(): deep observation slows the map and breaks API methods.
    Object.assign(this, {
      view: null,
      map: null,
      polygonsLayer: null,
      centroidLayer: null,
      fixedPointsLayer: null,
      ArcGISGraphic: null,
      ArcGISGraphicsLayer: null,
      ArcGISFeatureLayer: null,
      ArcGISPoint: null,
      ArcGISPictureMarkerSymbol: null,
    })
  },
  beforeDestroy() {
    destroyArcgisView(this.view)
    this.view = null
    this.map = null
  },
  async mounted() {
    await this.init()
    this.$store.dispatch('serviceTypes/fetchServiceTypes')
    await this.initMap()
    this.$watch('selectedBasemap', newVal => {
      if (this.map) {
        this.map.basemap = newVal
      }
    })
  },
  methods: {
    async initMap() {
      const [Map, MapView, GraphicsLayer, Graphic, FeatureLayer, Point, PictureMarkerSymbol] = await loadArcgisModules([
        'esri/Map',
        'esri/views/MapView',
        'esri/layers/GraphicsLayer',
        'esri/Graphic',
        'esri/layers/FeatureLayer',
        'esri/geometry/Point',
        'esri/symbols/PictureMarkerSymbol',
      ])
      this.ArcGISGraphic = Graphic
      this.ArcGISGraphicsLayer = GraphicsLayer
      this.ArcGISFeatureLayer = FeatureLayer
      this.ArcGISPoint = Point
      this.ArcGISPictureMarkerSymbol = PictureMarkerSymbol
      if (!this.$refs.mapDiv) return
      destroyArcgisView(this.view)
      this.map = new Map({ basemap: this.selectedBasemap })
      // Set center
      let center = [31.25, 31.06]
      let zoom = 10
      if (this.mapData && this.mapData.length > 0 && this.mapData[0].length > 0 && this.mapData[0][0].coordinates.length > 0) {
        const coord = this.mapData[0][0].coordinates[0]
        center = [Number(coord.longitude), Number(coord.latitude)]
        zoom = 12
      }
      this.view = new MapView({
        container: this.$refs.mapDiv,
        map: this.map,
        center,
        zoom,
      })
      // Add polygons layer
      this.polygonsLayer = new GraphicsLayer()
      this.map.add(this.polygonsLayer)
      // Add fixed points layer
      this.fixedPointsLayer = new GraphicsLayer({
        title: 'Fixed Points',
        visible: true,
      })
      this.map.add(this.fixedPointsLayer)
      // Add spatial clusters as a FeatureLayer (centroids)
      await this.initCentroidClusters(FeatureLayer, Graphic)
      // Listen to cluster/feature click
      this.setupCentroidLayerClick()
      // Fetch and render fixed points
      await this.fetchFixedPoints()
    },
    async initCentroidClusters(FeatureLayer, Graphic) {
      // Flatten all projects into flat array
      const centroidFeatures = []
      this.projectFlatList = []
      this.projectByObjectId = {}
      if (!this.mapData) return
      let idx = 0
      this.mapData.forEach((projectArray, groupIdx) => {
        // Skip empty project groups
        if (!Array.isArray(projectArray) || projectArray.length === 0) return
        projectArray.forEach((project, projIdx) => {
          // Skip any project with no coordinates or empty coordinates
          if (!Array.isArray(project.coordinates) || project.coordinates.length === 0) {
            // Optional: console.warn('Project skipped - empty coordinates', project);
            return
          }
          // Compute centroid of this polygon
          const coords = project.coordinates
          let latSum = 0; let
            lngSum = 0
          coords.forEach(c => {
            latSum += Number(c.latitude)
            lngSum += Number(c.longitude)
          })
          const center = [lngSum / coords.length, latSum / coords.length]
          centroidFeatures.push({
            geometry: {
              type: 'point',
              longitude: center[0],
              latitude: center[1],
            },
            attributes: {
              objectId: idx,
              groupIdx,
              projIdx,
              ...project,
            },
          })
          const flatProject = { ...project, groupIdx, projIdx }
          this.projectFlatList.push(flatProject)
          this.projectByObjectId[idx] = flatProject
          idx++
        })
      })
      // Create FeatureLayer for clustering
      this.centroidLayer = new FeatureLayer({
        source: centroidFeatures,
        objectIdField: 'objectId',
        geometryType: 'point',
        spatialReference: { wkid: 4326 },
        renderer: {
          type: 'simple',
          symbol: {
            type: 'simple-marker',
            style: 'circle',
            color: [255, 140, 0, 0.9],
            size: 18,
            outline: { color: [0, 0, 0], width: 1 },
          },
        },
        popupTemplate: {
          title: '{name}',
        },
        featureReduction: {
          type: 'cluster',
          clusterRadius: '80px', // tune as needed
          popupTemplate: {
            title: 'مشروعات المجموعة',
            content: 'عدد المشاريع: {cluster_count}',
          },
        },
        fields: [
          { name: 'objectId', type: 'oid' },
          { name: 'groupIdx', type: 'integer' },
          { name: 'projIdx', type: 'integer' },
          { name: 'name', type: 'string' },
        ],
      })
      this.map.add(this.centroidLayer)
    },
    setupCentroidLayerClick() {
      this.view.on('click', async event => {
        this.view.hitTest(event).then(response => {
          // For clusters, the layer will have multiple graphic.features
          const clusterHit = response.results.find(r => r.graphic.layer === this.centroidLayer)
          if (clusterHit) {
            if (clusterHit.graphic && clusterHit.graphic.isCluster) {
              // Get the ObjectIDs for all features in this cluster
              const objectIds = clusterHit.graphic.clusterGraphicId || []
              this.showClusterPolygons(clusterHit.graphic)
            } else {
              // Not a cluster, single point/project
              const attrs = clusterHit.graphic.attributes
              this.showPolygonForProject(attrs)
            }
          }
        })
      })
      // Re-render polygons on view scale change (auto update as clusters split)
      this.view.watch('scale', () => {
        // After zoom level changes, remove all polygons
        this.polygonsLayer.removeAll()
      })
    },
    showPolygonForProject(attrs) {
      this.polygonsLayer.removeAll()
      const project = this.projectByObjectId[attrs.objectId]
      if (!project) return
      const rings = [project.coordinates.map(coord => [Number(coord.longitude), Number(coord.latitude)])]
      let colorArr = [0, 128, 0, 0.4]
      if (/^#([0-9A-F]{6})$/i.test(project.color)) {
        colorArr = [
          parseInt(project.color.slice(1, 3), 16),
          parseInt(project.color.slice(3, 5), 16),
          parseInt(project.color.slice(5, 7), 16),
          0.4,
        ]
      }
      const symbol = {
        type: 'simple-fill',
        color: colorArr,
        outline: { color: [0, 0, 0, 0.7], width: 1 },
      }
      const polygon = {
        type: 'polygon',
        rings,
        spatialReference: { wkid: 4326 },
      }
      const graphic = new this.ArcGISGraphic({
        geometry: polygon,
        symbol,
        attributes: { name: project.name },
        popupTemplate: { title: project.name },
      })
      this.polygonsLayer.add(graphic)
    },
    showClusterPolygons(clusterGraphic) {
      this.polygonsLayer.removeAll()
      // clusterGraphic.features is an array of graphics in this cluster
      const features = clusterGraphic.features || []
      features.forEach(f => {
        const attrs = f.attributes
        this.showPolygonForProject(attrs)
      })
    },
    init() {
      this.$store.dispatch('projects/MapData', { query: this.filter })
    },
    async fetchFixedPoints() {
      try {
        const response = await this.$store.dispatch('fixedPoints/listFixedPoints', {
          query: {
            per_page: 1000, // Get all fixed points for the map
          },
        })
        console.log('Fixed points fetched, response:', response)
        // Render will be triggered by watcher, but also manually trigger after a delay
        this.$nextTick(() => {
          setTimeout(() => {
            this.renderFixedPoints()
          }, 300)
        })
      } catch (error) {
        console.error('Error fetching fixed points:', error)
        if (this.$toast) {
          this.$toast.error('حدث خطأ أثناء جلب النقاط الثابتة')
        }
      }
    },
    createPinIcon(colorHex) {
      // Create an SVG pin/marker icon with the specified color
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
          <!-- Pin shadow -->
          <ellipse cx="16" cy="36" rx="4" ry="2" fill="rgba(0,0,0,0.2)"/>
          <!-- Pin body -->
          <path d="M16 2C10.477 2 6 6.477 6 12c0 6 10 24 10 24s10-18 10-24C26 6.477 21.523 2 16 2z" 
                fill="${colorHex}" 
                stroke="#ffffff" 
                stroke-width="2"/>
          <!-- Pin center circle -->
          <circle cx="16" cy="12" r="5" fill="#ffffff"/>
          <circle cx="16" cy="12" r="3" fill="${colorHex}"/>
        </svg>
      `.trim()
      return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`
    },
    buildFixedPointTooltip(fixedPoint) {
      let content = '<div style="padding: 8px;">'
      content += `<p><strong>الكود:</strong> ${fixedPoint.code || '-'}</p>`

      if (fixedPoint.level) {
        content += `<p><strong>المستوى:</strong> ${fixedPoint.level}</p>`
      }

      if (fixedPoint.accuracy_degree_label_ar) {
        content += `<p><strong>درجة الدقة:</strong> ${fixedPoint.accuracy_degree_label_ar}</p>`
      }

      if (fixedPoint.responsible_employee) {
        content += `<p><strong>الموظف المسؤول:</strong> ${fixedPoint.responsible_employee.full_name || '-'}</p>`
      }

      // Show coordinates based on coord_type
      if (fixedPoint.coord_type === 'lat_lon' && fixedPoint.latitude && fixedPoint.longitude) {
        content += `<p><strong>خط العرض:</strong> ${fixedPoint.latitude}</p>`
        content += `<p><strong>خط الطول:</strong> ${fixedPoint.longitude}</p>`
      } else if (fixedPoint.coord_type === 'etm' && fixedPoint.etm_est && fixedPoint.etm_north) {
        content += `<p><strong>ETM East:</strong> ${fixedPoint.etm_est}</p>`
        content += `<p><strong>ETM North:</strong> ${fixedPoint.etm_north}</p>`
        if (fixedPoint.etm_zone) {
          content += `<p><strong>ETM Zone:</strong> ${fixedPoint.etm_zone}</p>`
        }
      } else if (fixedPoint.coord_type === 'utm' && fixedPoint.utm_est && fixedPoint.utm_north) {
        content += `<p><strong>UTM East:</strong> ${fixedPoint.utm_est}</p>`
        content += `<p><strong>UTM North:</strong> ${fixedPoint.utm_north}</p>`
        if (fixedPoint.utm_zone) {
          content += `<p><strong>UTM Zone:</strong> ${fixedPoint.utm_zone}</p>`
        }
      }

      content += '</div>'
      return content
    },
    renderFixedPoints() {
      if (!this.fixedPointsLayer || !this.ArcGISPoint || !this.ArcGISGraphic || !this.ArcGISPictureMarkerSymbol) {
        console.log('Fixed points layer or modules not ready')
        return
      }

      const { Point, Graphic, PictureMarkerSymbol } = {
        Point: this.ArcGISPoint,
        Graphic: this.ArcGISGraphic,
        PictureMarkerSymbol: this.ArcGISPictureMarkerSymbol,
      }

      this.fixedPointsLayer.removeAll()

      // Handle both array and object with data property
      let fixedPointsData = []
      if (Array.isArray(this.fixedPoints)) {
        fixedPointsData = this.fixedPoints
      } else if (this.fixedPoints?.data && Array.isArray(this.fixedPoints.data)) {
        fixedPointsData = this.fixedPoints.data
      } else if (this.fixedPoints?.data?.data && Array.isArray(this.fixedPoints.data.data)) {
        fixedPointsData = this.fixedPoints.data.data
      }

      if (!fixedPointsData.length) {
        console.log('No fixed points data to render')
        return
      }

      let renderedCount = 0

      fixedPointsData.forEach(fixedPoint => {
        const lat = parseFloat(fixedPoint.latitude)
        const lng = parseFloat(fixedPoint.longitude)

        if (!lat || !lng || isNaN(lat) || isNaN(lng) || lat === 0 || lng === 0) {
          return
        }

        // Validate coordinate ranges
        if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
          return
        }

        // Create point with longitude, latitude
        const point = new Point({
          longitude: lng,
          latitude: lat,
          spatialReference: { wkid: 4326 },
        })

        // Get color from accuracy_degree_color or default
        const colorHex = fixedPoint.accuracy_degree_color || '#0099ff'

        // Create pin-style marker
        const pinSvg = this.createPinIcon(colorHex)

        const symbol = new PictureMarkerSymbol({
          url: pinSvg,
          width: 32,
          height: 40,
          xoffset: 0,
          yoffset: 20, // Offset to position the pin point at the coordinates
        })

        // Build tooltip content
        const tooltipContent = this.buildFixedPointTooltip(fixedPoint)

        const graphic = new Graphic({
          geometry: point,
          symbol,
          attributes: {
            id: fixedPoint.id,
            code: fixedPoint.code,
            latitude: lat,
            longitude: lng,
            level: fixedPoint.level,
            accuracy_degree: fixedPoint.accuracy_degree_label_ar || fixedPoint.accuracy_degree,
            accuracy_degree_color: fixedPoint.accuracy_degree_color,
            responsible_employee: fixedPoint.responsible_employee
              ? fixedPoint.responsible_employee.full_name
              : '-',
            etm_est: fixedPoint.etm_est,
            etm_north: fixedPoint.etm_north,
            etm_zone: fixedPoint.etm_zone,
            utm_est: fixedPoint.utm_est,
            utm_north: fixedPoint.utm_north,
            utm_zone: fixedPoint.utm_zone,
            created_at: fixedPoint.created_at,
          },
          popupTemplate: {
            title: fixedPoint.code || 'نقطة ثابتة',
            content: tooltipContent,
          },
        })

        this.fixedPointsLayer.add(graphic)
        renderedCount++
      })

      console.log(`renderFixedPoints: Successfully rendered ${renderedCount} fixed points`)
    },
  },
}
</script>

<style scoped>
.arcgis-map-container .map-container-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
